// users/{uid}. Data-access slice 1 (brief section 5).
//
// Each method is exactly the one-liner it replaced: same path, the payload passed
// through untouched (no copy, no prefixing) and the Firestore promise returned as
// is, so callers keep whatever await / return / try shape they had.
//
// getDb is a function so this module never imports firebase or '@/main': db is
// read at call time, as actions.js already reads its imported binding today.
// node --test loads this file directly, and Node needs the extension.
import { userDoc } from '../paths.js'; // eslint-disable-line import/extensions

export default function usersRepository(getDb) {
    const doc = uid => userDoc(getDb(), uid);

    return {
        get: uid => doc(uid).get(),
        // The signed-in user's own record.
        update: (uid, patch) => doc(uid).update(patch),
        // Someone else's record (addLayerToCollaborators, removeLayerFromCollaborators,
        // removeCollaborator). Same call; named so these stay visible: the users rules
        // allow only self-or-admin writes, so for an ordinary owner they are denied
        // (brief, risk 2; inferred from the rules, unverified).
        updateOther: (uid, patch) => doc(uid).update(patch)
    };
}


// WEBPACK FOOTER //
// ./src/data/repositories/users.js